import { createSessionStorageStore } from '@/globals/webStorage/useWebStorage';
import {
	AccordionStoreSchema,
	AccordionStoreStringifySchema,
	AccordionState,
} from './accordionStore.types';

export const sessionStorageStore = createSessionStorageStore({
	key: 'accordionState',
	schema: AccordionStoreSchema,
	stringifySchema: AccordionStoreStringifySchema,
});

export const defaultState: AccordionState = {
	defaultItemOpenedState: null,
	items: new Map(),
};
